import { FormEvent } from 'react';
import * as _ from 'lodash';
import { ITicket, IUser, ITicketGroup, ISelectItem, ICenterBase, IListItem, IGroup } from '@nkr/models/index';
import { FormControl, ControlLabel, FormGroup } from 'react-bootstrap';
import { TicketType, UserGroup } from '@nkr/enums/index';
import { DropdownIndicator } from '@nkr/views/ticketing/dropdown-indicator';
import CreatableSelect from 'react-select/creatable';
import { DetailWrapper, ValueWrapper } from '../styles';

interface IProps {
    ticket: ITicket,
    userGroup: IGroup,
    userList: IUser[],
    ticketEntityTypeList: IListItem[],
    ticketTypeList: IListItem[],
    centerList: ICenterBase[],
    groupList: ITicketGroup[],
    urgencyList: IListItem[],
    tagList: ISelectItem[],
    onAssignedUserChange: (userId: number) => void,
    onCenterChange: (centerId: number) => void,
    onTicketTypeChange: (ticketTypeId: number) => void,
    onTierChange: (tierLevel: number) => void,
    onStatusChange: (status: number) => void,
    onGroupChange: (group: number) => void,
    onUrgencyChange: (urgency: number) => void,
    onTagsChange: (list: ISelectItem[]) => void
}

const Detail = (props: IProps) => {
    const handleAssignedUserChange = (e: FormEvent<FormControl & HTMLSelectElement>) => {
        props.onAssignedUserChange(parseInt(e.currentTarget.value));
    };

    const handleCenterChange = (e: FormEvent<FormControl & HTMLSelectElement>) => {
        props.onCenterChange(parseInt(e.currentTarget.value));
    };

    const handleTicketTypeChange = (e: FormEvent<FormControl & HTMLSelectElement>) => {
        props.onTicketTypeChange(parseInt(e.currentTarget.value));
    };

    const handleTierChange = (e: FormEvent<FormControl & HTMLSelectElement>) => {
        props.onTierChange(parseInt(e.currentTarget.value));
    };

    const handleStatusChange = (e: FormEvent<FormControl & HTMLSelectElement>) => {
        props.onStatusChange(parseInt(e.currentTarget.value));
    };

    const handleGroupChange = (e: FormEvent<FormControl & HTMLSelectElement>) => {
        props.onGroupChange(parseInt(e.currentTarget.value));
    };

    const handleUrgencyChange = (e: FormEvent<FormControl & HTMLSelectElement>) => {
        props.onUrgencyChange(parseInt(e.currentTarget.value));
    };

    const handleTagsChange = (list: ISelectItem[]) => {
        props.onTagsChange(list);
    };

    // const getCenterInfo = (): { centerId: number, centerAlias: string } => {
    //     let center = props.ticket.center;

    //     if (center) {
    //         return { centerId: center.id, centerAlias: center.alias };
    //     }

    //     return { centerId: 0, centerAlias: '' };
    // };

    if (props.ticket == null)
        return null;

    const groupList = _.sortBy(_.uniqBy(props.userList.map(x => x.group), (item) => item.id), item => item.id);
    const centerList = props.ticket.ticketTypeId == TicketType.MemberCenterRequest ? props.centerList.filter(x => x.isMemberCenter) : props.centerList.filter(x => x.isMemberCenter == false);

    const sortedTicketGroupList = _.sortBy(props.groupList.filter(x => x.category != 20), ['name']);

    return (
        <>
            <div className='row' style={{ marginBottom: 10 }}>
                <div className='col-xs-12 col-lg-12' style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 45, fontSize: 16, fontWeight: 600, borderTopLeftRadius: 4, borderTopRightRadius: 4 }}>
                    <div>PROPERTIES</div>
                </div>
            </div>

            <div className='row' style={{ marginBottom: 10, fontSize: 12 }}>
                <DetailWrapper className='col-xs-12 col-lg-12'>
                    <FormGroup>
                        <ControlLabel>Ticket #</ControlLabel>
                        <ValueWrapper>{props.ticket.id}</ValueWrapper>
                    </FormGroup>

                    <FormGroup>
                        <ControlLabel>Request Type</ControlLabel>
                        {props.userGroup.isSuper ?
                            <FormControl
                                componentClass='select'
                                style={{ paddingLeft: 6 }}
                                value={props.ticket.ticketTypeId}
                                onChange={handleTicketTypeChange}
                            >
                                <option value={-1}>- UNKNOWN -</option>
                                {props.ticketTypeList.map((item, index) =>
                                    <option key={`tt-${index}`} value={item.id}>{item.description}</option>
                                )}
                            </FormControl>
                            :
                            <ValueWrapper>{props.ticket.ticketTypeName}</ValueWrapper>
                        }
                    </FormGroup>

                    {(props.ticket.ticketTypeId == TicketType.MemberCenterRequest || props.ticket.ticketTypeId == TicketType.ContactPageNonMemberCenter) && props.userGroup.isSuper && (
                        <FormGroup>
                            <ControlLabel>{props.ticket.ticketTypeId == TicketType.MemberCenterRequest ? 'Member Center' : 'Non-member Center'}</ControlLabel>
                            <FormControl
                                componentClass='select'
                                value={props.ticket.entityTypeId}
                                onChange={handleCenterChange}
                            >
                                <option value={0}>- NOT ASSIGNED - </option>
                                {centerList.map((center, index) =>
                                    <option key={`ctr-${index}`} value={center.id}>{center.alias}</option>
                                )}
                            </FormControl>
                        </FormGroup>
                    )}

                    <FormGroup>
                        <ControlLabel>Agent</ControlLabel>
                        <FormControl
                            componentClass='select'
                            style={{ paddingLeft: 6 }}
                            value={props.ticket.assignedUserId}
                            onChange={handleAssignedUserChange}
                        >
                            <option value={0}>- NOT ASSIGNED - </option>
                            {groupList.map((group, index) => {
                                let userList = props.userList.filter(x => x.groupId == group.id);

                                return (
                                    <optgroup key={index} label={group.id == UserGroup.Admin ? 'NKR' : group.name}>
                                        {userList.map((user, index2) =>
                                            <option key={index2} value={user.id}>&nbsp;&nbsp;&nbsp;{user.lastName}, {user.firstName}</option>
                                        )}
                                    </optgroup>
                                );
                            })}
                        </FormControl>
                    </FormGroup>

                    <FormGroup>
                        <ControlLabel>Status</ControlLabel>
                        <FormControl
                            componentClass='select'
                            style={{ paddingLeft: 6 }}
                            value={props.ticket.ticketStatusId}
                            onChange={handleStatusChange}
                        >
                            <option value={1}>Open</option>
                            <option value={2}>Pending</option>
                            <option value={3}>Closed</option>
                            <option value={4}>Resolved</option>
                            <option value={5}>Reopened</option>
                        </FormControl>
                    </FormGroup>

                    <FormGroup>
                        <ControlLabel>Tier</ControlLabel>
                        {props.userGroup.isSuper ?
                            <FormControl
                                componentClass='select'
                                style={{ paddingLeft: 6 }}
                                value={props.ticket.tierLevelId}
                                onChange={handleTierChange}
                            >
                                <option value={1}>Tier 1</option>
                                <option value={2}>Tier 2</option>
                                <option value={3}>Tier 3</option>
                            </FormControl>
                            :
                            <ValueWrapper>{props.ticket.tierLevelName}</ValueWrapper>
                        }
                    </FormGroup>

                    <FormGroup>
                        <ControlLabel>Group</ControlLabel>
                        {props.userGroup.isSuper ?
                            <FormControl
                                componentClass='select'
                                style={{ paddingLeft: 6 }}
                                value={props.ticket.groupId}
                                onChange={handleGroupChange}
                            >
                                <option value={0}>- NOT ASSIGNED -</option>
                                {sortedTicketGroupList.map((group, index) =>
                                    <option key={`g-${index}`} value={group.id}>{group.name}</option>
                                )}
                            </FormControl>
                            :
                            <ValueWrapper className='form-control'>{props.ticket.groupName}</ValueWrapper>
                        }
                    </FormGroup>

                    <FormGroup>
                        <ControlLabel>Urgency</ControlLabel>
                        {props.userGroup.isSuper ?
                            <FormControl
                                componentClass='select'
                                style={{ paddingLeft: 6 }}
                                value={props.ticket.urgencyId}
                                onChange={handleUrgencyChange}
                            >
                                {props.urgencyList.map((item, index) =>
                                    <option key={`ul-${index}`} value={item.id}>{item.description}</option>
                                )}
                            </FormControl>
                            :
                            <ValueWrapper className='form-control'>{props.ticket.urgencyName}</ValueWrapper>
                        }
                    </FormGroup>

                    <FormGroup>
                        <ControlLabel>Tags</ControlLabel>
                        <CreatableSelect
                            defaultValue={[]}
                            value={props.ticket.tags.map(x => { return { value: x.id.toString(), label: x.tag }; })}
                            isMulti
                            name='tags'
                            options={props.tagList}
                            components={{ DropdownIndicator }}
                            styles={{
                                indicatorSeparator: defaultStyles => ({ ...defaultStyles }),
                                dropdownIndicator: defaultStyles => ({
                                    ...defaultStyles,
                                    color: 'black'
                                }),
                                multiValueLabel: (styles) => ({
                                    ...styles,
                                    backgroundColor: 'pink',
                                    fontSize: 14
                                }),
                                multiValueRemove: (styles) => ({
                                    ...styles,
                                    backgroundColor: 'pink'
                                }),
                            }}
                            onChange={handleTagsChange}
                        />
                    </FormGroup>
                </DetailWrapper>
            </div>
        </>
    );
}

export default Detail;